import { render, staticRenderFns } from "./userSetting.vue?vue&type=template&id=52665d9c&scoped=true&"
import script from "./userSetting.vue?vue&type=script&lang=js&"
export * from "./userSetting.vue?vue&type=script&lang=js&"
import style0 from "./userSetting.vue?vue&type=style&index=0&id=52665d9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52665d9c",
  null
  
)

export default component.exports